import { render, staticRenderFns } from "./LottosetConfirm.vue?vue&type=template&id=8c6fb6d2&scoped=true&"
import script from "./LottosetConfirm.vue?vue&type=script&lang=js&"
export * from "./LottosetConfirm.vue?vue&type=script&lang=js&"
import style0 from "./LottosetConfirm.vue?vue&type=style&index=0&id=8c6fb6d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6fb6d2",
  null
  
)

export default component.exports